import { render } from "./UserFeedbackPage.vue?vue&type=template&id=6fdcb7e8"
import script from "./UserFeedbackPage.vue?vue&type=script&lang=js"
export * from "./UserFeedbackPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__